module.exports = __webpack_public_path__ + "img/step4.9df8235d.png";